import { CommonWorkflowService } from '@savgroup-front-common/core/api';
import getTechnicalInterventionQuery from '@savgroup-front-common/core/api/Workflow/getTechnicalInterventionQuery';

import cancelTechnicalIntervention from './cancelTechnicalIntervention';
import createTechnicalIntervention from './createTechnicalIntervention';
import getClosedFilesQuery from './getClosedFilesQuery';
import getCustomerFileFullSummaryQuery from './getCustomerFileFullSummaryQuery';
import getFileActionsQuery from './getFileActionsQuery';
import getFilesByOrderQuery from './getFilesByOrderQuery';
import getOpenedFilesQuery from './getOpenedFilesQuery';
import getOwnerFileQuery from './getOwnerFileQuery';
import getTechnicalInterventionTimeSlots from './getTechnicalInterventionTimeSlots';
import setFileActionCommand from './setFileActionCommand';

export const WorkflowService = {
  getOpenedFilesQuery,
  getClosedFilesQuery,
  getCustomerFileFullSummaryQuery,
  getFilesByOrderQuery,
  getFileActionsQuery,
  setFileActionCommand,
  getOwnerFileQuery,
  getTechnicalInterventionQuery,
  getTechnicalInterventionTimeSlots,
  createTechnicalIntervention,
  cancelTechnicalIntervention,
  getShortFileInfoQuery: CommonWorkflowService.getShortFileInfoQuery,
};
